import type { PersonProfile } from '@openeducation/oe-rn-shared-types';
import jwtDecode from 'jwt-decode';

import { TEACHER_PORTAL_ROLES } from '../consts';
import type { Environment, SessionJWT } from '../interfaces';
import { PersonProfileService } from '../services';

export const teacherProfileAuthorization =
  (environment: Environment) => async (tokenInformation: string) => {
    const cleanToken = jwtDecode<SessionJWT>(tokenInformation);

    const teacherProfile = await PersonProfileService.getProfileById(
      environment,
      cleanToken.PERSON_ID
    );

    if (!TEACHER_PORTAL_ROLES[teacherProfile.roleDto.roleType.toLowerCase()])
      throw Error('Role does not work here');

    return teacherProfile;
  };

export const isTeacherProfile = (teacherProfile: PersonProfile) =>
  !!TEACHER_PORTAL_ROLES[teacherProfile.roleDto.roleType.toLowerCase()];

export const isSystemAdminProfile = (teacherProfile: PersonProfile) =>
  TEACHER_PORTAL_ROLES[teacherProfile.roleDto.roleType.toLowerCase()] ===
  TEACHER_PORTAL_ROLES.sysadmin;
